/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import PropTypes from "prop-types";

import "./Toogle.scss";

const Toogle = ({ text, checked, onChecked }) => (
	<label className="switch">
		<input
			type="checkbox"
			onChange={() => onChecked(!checked)}
			checked={checked}
		/>
		<span className="slider round" />
		<span className="font-regular text">{text}</span>
	</label>
);

Toogle.propTypes = {
	text: PropTypes.string.isRequired,
	checked: PropTypes.bool.isRequired,
	onChecked: PropTypes.func.isRequired,
};

export default Toogle;
